import React from 'react';
import { ArrowRight, LogIn } from 'lucide-react';
import { SITE_AREAS } from '../site/areasContent';

const TICKER = ['Report di affidabilità', 'Titolari effettivi', 'PEP e sanzioni', 'Adverse media', 'Grafo societario', 'Check candidato', 'Whistleblowing D.Lgs. 24/2023',
  'Rischio Paese', 'Allerte meteo e sanitarie', 'Conferma di arrivo', 'Questionario NIS2', 'Data breach', 'Penetration test', 'Dark web', 'Device management'];

export default function HomeHero() {
  return (
    <section className="relative min-h-[100svh] flex flex-col justify-center overflow-hidden bg-[#050505] pt-28" data-testid="home-hero">
      <div className="absolute inset-0 home-grid opacity-60" />
      <div className="absolute right-[-20%] top-1/2 -translate-y-1/2 w-[900px] h-[900px] rounded-full home-radar pointer-events-none" />
      <div className="relative max-w-7xl mx-auto w-full px-6 md:px-12 lg:px-24">
        <p className="font-mono text-xs uppercase tracking-[0.3em] text-[#D4AF37] mb-8 home-rise">Business intelligence · Compliance · Security</p>
        <h1 className="font-heading font-bold text-4xl sm:text-5xl lg:text-7xl text-white leading-[1.02] tracking-tight max-w-5xl home-rise" style={{ animationDelay: '80ms' }}>
          Conosci chi hai davanti<br /><span className="text-[#D4AF37]">e gestisci i tuoi rischi.</span>
        </h1>
        <p className="text-base lg:text-lg text-[#A3A3A3] max-w-2xl mt-8 home-rise" style={{ animationDelay: '160ms' }}>
          BOND riunisce in un'unica piattaforma i rischi finanziari, delle persone, dei viaggi e informatici: dati ufficiali, verifiche e obblighi di legge, sempre sotto controllo.
        </p>
        <div className="flex flex-wrap gap-4 mt-10 home-rise" style={{ animationDelay: '240ms' }}>
          <a href="/subscribe" className="h-12 px-7 rounded-full bg-[#D4AF37] hover:bg-[#E6C547] text-black font-semibold inline-flex items-center gap-2 transition-colors" data-testid="home-cta-subscribe">Richiedi accesso<ArrowRight size={18} /></a>
          <a href="/portal/login" className="h-12 px-7 rounded-full border border-[#D4AF37]/40 hover:border-[#D4AF37] text-white inline-flex items-center gap-2 transition-colors" data-testid="home-cta-login"><LogIn size={18} />Accedi a BOND</a>
        </div>
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-px bg-[#1F1F1F] mt-16 border border-[#1F1F1F] home-rise" style={{ animationDelay: '320ms' }}>
          {SITE_AREAS.map((a, i) => {
            const Icon = a.icon;
            return (
              <a key={a.id} href={`#area-${a.id}`} className="group bg-[#050505]/90 backdrop-blur p-5 flex items-center gap-3 hover:bg-[#0D0D0D] transition-colors" data-testid={`home-hero-area-${a.id}`}>
                <span className="font-mono text-[10px] text-[#525252]">0{i + 1}</span>
                <Icon size={18} style={{ color: a.tone }} />
                <span className="text-sm text-[#E5E5E5] group-hover:text-white">{a.title}</span>
              </a>
            );
          })}
        </div>
      </div>
      <div className="relative mt-16 border-y border-[#1F1F1F] py-4 overflow-hidden" aria-hidden>
        <div className="home-ticker flex gap-10 whitespace-nowrap font-mono text-xs uppercase tracking-[0.2em] text-[#737373]">
          {[...TICKER, ...TICKER].map((t, i) => <span key={i} className="inline-flex items-center gap-10">{t}<span className="w-1.5 h-1.5 rounded-full bg-[#D4AF37]" /></span>)}
        </div>
      </div>
    </section>
  );
}
